import { render, staticRenderFns } from "./DeleteAccountCard.vue?vue&type=template&id=d2c9dbf8&scoped=true&"
import script from "./DeleteAccountCard.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountCard.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountCard.vue?vue&type=style&index=0&id=d2c9dbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c9dbf8",
  null
  
)

export default component.exports